import { render, staticRenderFns } from "./form10.vue?vue&type=template&id=89e8e8b8&scoped=true"
import script from "./form10.vue?vue&type=script&lang=js"
export * from "./form10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e8e8b8",
  null
  
)

export default component.exports